import React from 'react';
import { Menu, Container, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const NavBar = () => {
    return (
        <Menu fixed='top' inverted>
            <Container>
                <Menu.Item header >
                    <Image src='/assets/prymera.png'
                        size="small"
                        centered
                        as={Link}
                        to='/' />
                </Menu.Item>
            </Container>
        </Menu>
    )
}

export default NavBar
